import React, { useState, useEffect, useRef } from 'react';
import { Link, useNavigate } from 'react-router-dom';

import signInIcon from '../../assets/Frame68.png';
import logo from "../../assets/logoo.png";
import homeIcon from '../../assets/homeicon.png';
import productsIcon from '../../assets/Productsandofferingsicon.png';
import aboutUsIcon from '../../assets/aboutusicon.png';
import faqsIcon from '../../assets/faqsicon.png';
import contactUsIcon from '../../assets/contactusicon.png';
import hamburgerIcon from '../../assets/hamburger.png'; // Add hamburger icon asset
import closeIcon from '../../assets/close.png'; // Add close icon asset

import './Nav.css';

const Navbar = () => {
  const [isOpen, setIsOpen] = useState(false); // Mobile menu state
  const [showProductsDropdown, setShowProductsDropdown] = useState(false); // Dropdown state for products
  const [showDropdown, setShowDropdown] = useState(false); // Dropdown state for "More"
  const navigate = useNavigate();
  const mobileMenuRef = useRef(null); // Ref to track the mobile menu

  const toggleMenu = () => {
    setIsOpen(prevState => {
      const newState = !prevState;
      const mobileMenu = mobileMenuRef.current;
      if (mobileMenu) {
        mobileMenu.classList.toggle('active', newState);
      }
      return newState;
    });
  };

  const closeNavbar = () => {
    setIsOpen(false);
    const mobileMenu = mobileMenuRef.current;
    if (mobileMenu) {
      mobileMenu.classList.remove('active');
    }
  };

  const toggleProductsDropdown = () => {
    setShowProductsDropdown(!showProductsDropdown);
  };

  const toggleDropdown = () => {
    setShowDropdown(!showDropdown);
  };

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (mobileMenuRef.current && !mobileMenuRef.current.contains(event.target) && !event.target.closest('.navbar__menu-icon')) {
        closeNavbar();
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);

  return (
    <nav className="navbar">
      <div className={`navbar__container ${isOpen ? 'menu-open' : ''}`}>
        {/* Logo and Hamburger in Navbar */}
        <div className="navbar__logo">
          <img src={logo} alt="Polymath Kids Logo" className="navbar__logo-image" />
        </div>
        <div className="navbar__menu-icon" onClick={toggleMenu}>
          <img src={hamburgerIcon} alt="Menu" className="navbar__hamburger-icon" />
        </div>

        {/* Navbar Links (Desktop) */}
        <ul className="navbar__menu">
          <li className="navbar__item navbar__item--animated navbar__item--home">
            <Link to="/" className="navbar__link">
              <img src={homeIcon} alt="Home" className="navbar__custom-icon" />
              <span>Home</span>
            </Link>
          </li>
          <li className="navbar__item navbar__item--animated navbar__item--has-dropdown">
            <span className="navbar__link" onClick={() => setShowProductsDropdown(!showProductsDropdown)}>
              <img src={productsIcon} alt="Products" className="navbar__custom-icon" />
              <span>Products And Offerings</span>
              <span className={`navbar__arrow ${showProductsDropdown ? "navbar__arrow--up" : "navbar__arrow--down"}`}></span>
            </span>
            {showProductsDropdown && (
              <div className="navbar__stem-dropdown">
                <Link to="/life-skill-courses" className="navbar__dropdown-link" onClick={() => setShowProductsDropdown(false)}>
                  Life Skill Courses
                </Link>
                <Link to="/polymatch" className="navbar__dropdown-link" onClick={() => setShowProductsDropdown(false)}>
                  PolyMatch
                </Link>
                <Link to="/polymathkids_at_schools" className="navbar__dropdown-link" onClick={() => setShowProductsDropdown(false)}>
                  Polymath-Kids @ Schools
                </Link>
              </div>
            )}
          </li>
          <li className="navbar__item navbar__item--animated">
            <Link to="/about-us" className="navbar__link">
              <img src={aboutUsIcon} alt="About Us" className="navbar__custom-icon" />
              <span>About Us</span>
            </Link>
          </li>
          <li className="navbar__item navbar__item--animated">
            <Link to="/faqs" className="navbar__link">
              <img src={faqsIcon} alt="FAQs" className="navbar__custom-icon" />
              <span>FAQs</span>
            </Link>
          </li>
          <li className="navbar__item navbar__item--animated">
            <Link to="/contact-us" className="navbar__link">
              <img src={contactUsIcon} alt="Contact Us" className="navbar__custom-icon" />
              <span>Contact Us</span>
            </Link>
          </li>
        </ul>

        {/* Sign In Icon */}
        <Link to="/sign-in" className="navbar__sign-in-icon">
          <img src={signInIcon} alt="Sign In" />
        </Link>

        {/* More Dropdown (on small screens) */}
        {isOpen && (
          <div className="navbar__dropdown">
            <button className="navbar__dropdown-btn" onClick={toggleDropdown}>
              More{" "}
              <span className={`navbar__arrow ${showDropdown ? "navbar__arrow--up" : "navbar__arrow--down"}`}></span>
            </button>
            {showDropdown && (
              <div className="navbar__dropdown-content">
                <Link to="/vision" className="navbar__dropdown-link" onClick={() => {
                  setIsOpen(false);
                  setShowDropdown(false);
                }}>
                  Our Vision
                </Link>
                <Link to="/terms-of-service" className="navbar__dropdown-link" onClick={() => {
                  setIsOpen(false);
                  setShowDropdown(false);
                }}>
                  Terms of Use
                </Link>
                <Link to="/privacy-policy" className="navbar__dropdown-link" onClick={() => {
                  setIsOpen(false);
                  setShowDropdown(false);
                }}>
                  Privacy Policy
                </Link>
                <Link to="/cancellation-policy" className="navbar__dropdown-link" onClick={() => {
                  setIsOpen(false);
                  setShowDropdown(false);
                }}>
                  Cancellation & Refund Policy
                </Link>
              </div>
            )}
          </div>
        )}

        {/* Mobile Navbar (Visible when hamburger is clicked) */}
        <div className="navbar__mobile-menu" ref={mobileMenuRef}>
          {/* Close Button */}
          <button className="navbar__close-btn" onClick={closeNavbar}>
            <img src={closeIcon} alt="Close" className="navbar__close-icon" />
          </button>

          {/* Mobile Logo */}
          <div className="navbar__mobile-logo">
            <img src={logo} alt="Polymath Kids Logo" className="navbar__mobile-logo-image" />
          </div>

          {/* Mobile Menu Items */}
          <ul className="navbar__mobile-menu-items">
            <li className="navbar__item navbar__item--home">
              <Link to="/" className="navbar__link">
                <img src={homeIcon} alt="Home" className="navbar__custom-icon" />
                <span>Home</span>
              </Link>
            </li>
            <li className="navbar__item navbar__item--has-dropdown">
              <span className="navbar__link" onClick={toggleProductsDropdown}>
                <img src={productsIcon} alt="Products" className="navbar__custom-icon" />
                <span>Products And Offerings</span>
                <span className={`navbar__arrow ${showProductsDropdown ? "navbar__arrow--up" : "navbar__arrow--down"}`}></span>
              </span>
              {showProductsDropdown && (
                <div className="navbar__stem-dropdown">
                  <Link to="/life-skill-courses" className="navbar__dropdown-link">
                    Life Skill Courses
                  </Link>
                  <Link to="/polymatch" className="navbar__dropdown-link">
                    PolyMatch
                  </Link>
                  <Link to="/polymathkids_at_schools" className="navbar__dropdown-link">
                    Polymath-Kids @ Schools
                  </Link>
                </div>
              )}
            </li>
            <li className="navbar__item">
              <Link to="/about-us" className="navbar__link">
                <img src={aboutUsIcon} alt="About Us" className="navbar__custom-icon" />
                <span>About Us</span>
              </Link>
            </li>
            <li className="navbar__item">
              <Link to="/faqs" className="navbar__link">
                <img src={faqsIcon} alt="FAQs" className="navbar__custom-icon" />
                <span>FAQs</span>
              </Link>
            </li>
            <li className="navbar__item">
              <Link to="/contact-us" className="navbar__link">
                <img src={contactUsIcon} alt="Contact Us" className="navbar__custom-icon" />
                <span>Contact Us</span>
              </Link>
            </li>
          </ul>

          {/* Sign Up Button */}
          <Link to="/sign-in" className="navbar__sign-up-btn">
            Sign Up
          </Link>
        </div>
      </div>
    </nav>
  );
};

export default Navbar;